<div class="pie-chart" style="position: relative" [style.width]="width" [style.height]="height + 'px'" *ngIf="width">
  <canvas id="pieChart{{id}}" [style.width]="width"></canvas>
</div>
